module.exports = __webpack_public_path__ + "static/media/LaoSaPaoHuevoSalado.72a76330.jpg";